// extracted by mini-css-extract-plugin
export default {"wrapper":"chatbot-content_wrapper__rHG3d","messages_wrapper":"chatbot-content_messages_wrapper__Jiqq1"};